export function bucketNotifications(notifications) {
  const now = Date.now();
  const buckets = {
    today: [],
    week: [],
    older: [],
  };

  notifications.forEach(n => {
    const created = new Date(n.created_at).getTime();
    const hours = (now - created) / 36e5;

    if (hours < 24) buckets.today.push(n);
    else if (hours < 24 * 7) buckets.week.push(n);
    else buckets.older.push(n);
  });

  return buckets;
}
